import { restoreAccessToken, secureAxios } from "../constant/auth";
import { BASE_URL, IMAGE_BASE_URL } from "../constant/constant";
// import {restoreAccessToken} from "../constant"

// export function getImageURL(id) {
//   if (id) {
//     return `${BASE_URL}assets/${id}?&access_token=${restoreAccessToken()}`;
//   }
// }

export const getImageURL = (path) => {
  if (path?.length > 100) {
    return path;
  }
  return `${IMAGE_BASE_URL}/${path}`;
};

export function getImageURLwithouttoken(id) {
  if (id) {
    return `${BASE_URL}assets/${id}`;
  }
}

export const getUserProfileId = async (userId) => {
  try {
    const response = await secureAxios.get(
      `/users/${userId}?fields=profile_image`
    );
    return {
      imgId: response.data.profile_image,
      imgUrl: getImageURL(response.data.profile_image),
    };
  } catch (error) {
    //(error);
  }
};
